import "./style.css";
import { IoMdBusiness } from "react-icons/io";
import { GiGraduateCap } from "react-icons/gi";
import { useLanguage } from "../../context/LanguageContext";

const Resume = () => {
  const { t } = useLanguage();
  const jobs = t("resume.jobs");

  return (
    <section id="resume" className="grey-section">
      <div className="row section-intro">
        <div className="col-twelve">
          <h5>{t("resume.title")}</h5>
          <h1>{t("resume.subtitle")}</h1>
        </div>
      </div>

      <div className="row resume-timeline">
        <div className="col-twelve resume-header">
          <h2>{t("resume.workExperience")}</h2>
        </div>

        <div className="col-twelve">
          <div className="timeline-wrap">
            {jobs.map((job, index) => (
              <div className="timeline-block" key={index}>
                <div className="timeline-ico">
                  <IoMdBusiness />
                </div>

                <div className="timeline-header">
                  <h3>{job.position}</h3>
                  <p>{job.date}</p>
                </div>

                <div className="timeline-content">
                  <div className="job-title">
                    <h4>{job.company}</h4>
                    <p className="job-location">{job.location}</p>
                  </div>
                  <ul>
                    {job.responsibilities.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="row resume-timeline">
        <div className="col-twelve resume-header">
          <h2>{t("resume.education")}</h2>
        </div>

        <div className="col-twelve">
          <div className="timeline-wrap">
            <div className="timeline-block">
              <div className="timeline-ico">
                <GiGraduateCap />
              </div>

              <div className="timeline-header">
                <h3>{t("resume.bachelorsDegree")}</h3>
                <p>2017 - 2022 | Izmir</p>
              </div>

              <div className="timeline-content">
                <h4>{t("resume.university")}</h4>
                <p>GPA : 3.07 / 4.00</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume;
